import Colors from "assets/Colors";
import PieChartCustom from "components/common/PieChart";
import AlertIcon from "components/icons/AlertIcon";
import Loading from "components/common/loading";
import { useTranslation } from "react-i18next";
import s from "./styles";

function MoneyLine({ color, text, total = 0, last }) {
  return (
    <s.MoneyLine last={last}>
      <s.ContainerColorPaymentType>
        <s.RoundColor style={{ background: color }} />
        <s.PaymentTypeText>{text}</s.PaymentTypeText>
      </s.ContainerColorPaymentType>
      <s.Money>{total}</s.Money>
    </s.MoneyLine>
  );
}

function PieChartSubcategory({
  SubcategorySummary,
  loadingSubCategories,
  secondGraph,
}) {
  const { t } = useTranslation();
  const data = [];

  SubcategorySummary.forEach((item, index) => {
    if (index > 2) return;
    data.push({
      name: item._id?.itemName || item.name,
      value: item.quantity,
      color: index === 0 ? Colors.text_on_primary : Colors.text_primary,
      background:
        index == 0
          ? `${Colors.primary_web}`
          : index == 1
          ? `${Colors.primary_web_color1}80`
          : `${Colors.primary_web_color1}40`,
    });
  });

  const other = SubcategorySummary.reduce(
    (acc, item, index) => (index > 2 ? acc + parseInt(item.quantity) : acc),
    0
  );

  data.push({
    name: t("components.ReportsItems.PieChartSubCategory.others"),
    value: other,
    color: Colors.text_primary,
    background: `${Colors.primary_web_color1}15`,
  });

  return (
    <s.Container ref={secondGraph}>
      <s.Title>
        {t("components.ReportsItems.PieChartSubCategory.bestSellingUnits")}
      </s.Title>
      {!loadingSubCategories ? (
        <>
          {SubcategorySummary.length > 0 ? (
            <div>
              <s.BodyContainer>
                <s.body>
                  <s.LeftBodyContainer>
                    {SubcategorySummary.map((item, index) => {
                      if (index > 2) return null;
                      return (
                        <MoneyLine
                          key={index}
                          color={
                            index == 0
                              ? `${Colors.primary_web}`
                              : index == 1
                              ? `${Colors.primary_web_color1}80`
                              : `${Colors.primary_web_color1}40`
                          }
                          // text={item?._id?.subcategoryName}
                          text={item._id?.itemName || item.name}
                          total={item.quantity}
                        />
                      );
                    })}
                    <MoneyLine
                      color={`${Colors.primary_web_color1}15`}
                      // text={item?._id?.subcategoryName}
                      text="Otros"
                      total={other}
                    />
                  </s.LeftBodyContainer>
                </s.body>
                <s.pieChartContainer>
                  <div>
                    <PieChartCustom data={data} />
                  </div>
                </s.pieChartContainer>
              </s.BodyContainer>
            </div>
          ) : (
            <s.NoItemsContainer>
              <s.NoItemsMessageCenter>
                <AlertIcon style={{ display: "block", marginBottom: "7px" }} />
                {t("general.noData")}
              </s.NoItemsMessageCenter>
            </s.NoItemsContainer>
          )}
        </>
      ) : (
        <Loading height="260px" size="middle" />
      )}
    </s.Container>
  );
}

export default PieChartSubcategory;
